import { CSSProperties } from "react";
import { motion } from "motion/react";
import COLORS from "../config/colors";
import Icon from "./Icon";

export function RoundIconButton({
  icon = "",
  large = false,
  dark = false,
  disabled = false,
  onClick,
  className,
  style = {}
}: {
  icon?: string;
  large?: boolean;
  dark?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  className?: string;
  style: CSSProperties;
}) {
  return (
    <motion.div
      onClick={e => {
        e.preventDefault();
        e.stopPropagation();
        onClick?.();
      }}
      style={{
        cursor: disabled ? "default" : "pointer",
        pointerEvents: "all",
        position: "absolute",
        zIndex: 3,
        top: 0,
        width: large ? "4rem" : "2.4rem",
        height: large ? "4rem" : "2.4rem",
        lineHeight: large ? "4rem" : "2.4rem",
        textAlign: "center",
        borderRadius: "50%",
        border: "1px solid " + COLORS.background,
        background: dark ? COLORS.bjelin_dark_grey : COLORS.background,
        fontSize: large ? "2em" : "1.2em",
        ...style
      }}
      initial={{
        opacity: 0
      }}
      animate={{
        color: disabled
          ? dark
            ? COLORS.bjelin_grey
            : COLORS.bjelin_light_grey
          : dark
          ? COLORS.background
          : COLORS.bjelin_dark_grey,
        opacity: disabled ? 0.2 : 1
      }}
      className={className}
    >
      <Icon name={icon} />
    </motion.div>
  );
}
